import { useMemo } from 'react'

import { SatuEventTracker } from '../core/SatuEventTracker'

import type { TrackEventArgs } from '../core/SatuEventTracker'
import type { SessionProvider } from '../auth/types'

interface UseTrackerOptions {
  sessionProvider?: SessionProvider
}

export interface UseSatuEventTrackerReturn {
  SETrackEvent: (args: TrackEventArgs) => void
  SETransformAttrs: typeof SatuEventTracker.prototype.transformAttrs
  tracker: SatuEventTracker
}

export const useSatuEventTracker = (
  options: UseTrackerOptions = {}
): UseSatuEventTrackerReturn => {
  const tracker = useMemo(
    () => SatuEventTracker.getInstance(undefined, options.sessionProvider),
    [options.sessionProvider]
  )

  return {
    SETrackEvent: tracker.trackEvent.bind(tracker),
    SETransformAttrs: tracker.transformAttrs,
    tracker,
  }
}
